/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBillingStripeCreditBalance200ResponseBalance
 */
export interface GetBillingStripeCreditBalance200ResponseBalance {
    /**
     * Available credit balance in cents
     * @type {number}
     * @memberof GetBillingStripeCreditBalance200ResponseBalance
     */
    availableBalanceCents?: number;
    /**
     * Ledger credit balance in cents
     * @type {number}
     * @memberof GetBillingStripeCreditBalance200ResponseBalance
     */
    ledgerBalanceCents?: number;
    /**
     * Currency code (e.g. usd)
     * @type {string}
     * @memberof GetBillingStripeCreditBalance200ResponseBalance
     */
    currency?: string;
}

/**
 * Check if a given object implements the GetBillingStripeCreditBalance200ResponseBalance interface.
 */
export function instanceOfGetBillingStripeCreditBalance200ResponseBalance(value: object): value is GetBillingStripeCreditBalance200ResponseBalance {
    return true;
}

export function GetBillingStripeCreditBalance200ResponseBalanceFromJSON(json: any): GetBillingStripeCreditBalance200ResponseBalance {
    return GetBillingStripeCreditBalance200ResponseBalanceFromJSONTyped(json, false);
}

export function GetBillingStripeCreditBalance200ResponseBalanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingStripeCreditBalance200ResponseBalance {
    if (json == null) {
        return json;
    }
    return {
        
        'availableBalanceCents': json['availableBalanceCents'] == null ? undefined : json['availableBalanceCents'],
        'ledgerBalanceCents': json['ledgerBalanceCents'] == null ? undefined : json['ledgerBalanceCents'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function GetBillingStripeCreditBalance200ResponseBalanceToJSON(json: any): GetBillingStripeCreditBalance200ResponseBalance {
    return GetBillingStripeCreditBalance200ResponseBalanceToJSONTyped(json, false);
}

export function GetBillingStripeCreditBalance200ResponseBalanceToJSONTyped(value?: GetBillingStripeCreditBalance200ResponseBalance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'availableBalanceCents': value['availableBalanceCents'],
        'ledgerBalanceCents': value['ledgerBalanceCents'],
        'currency': value['currency'],
    };
}

